// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3xea3","inputWrap":"CustomTip_inputWrap__4XoTU"};